/**
 * Bumble & Bloom — Airabella Theme JavaScript
 * Small, dependency-free. Handles mobile nav toggle and scroll effects.
 */
(function () {
  'use strict';

  // ── Mobile nav toggle ─────────────────────────────────────────────────
  var toggle = document.querySelector('.mobile-menu-toggle');
  var nav = document.getElementById('main-nav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  }

  // ── Close nav on ESC ──────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }
  });

  // ── Scroll-aware header shadow ───────────────────────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ── Intersection Observer for fade-in cards ──────────────────────────
  if ('IntersectionObserver' in window) {
    var cards = document.querySelectorAll('.product-card, .card');
    if (cards.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );
      cards.forEach(function (card) { observer.observe(card); });
    }
  }

  // ── Quick-add from product grid ──────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add');
    if (!btn) return;

    var form = btn.closest('form') || btn.closest('form[data-add-to-cart]');
    if (!form) return;

    try {
      var input = form.querySelector('input[name=id]') ||
                  form.querySelector('select[name=id]');
      if (!input) return;

      var productId = input.value;
      var qty = form.querySelector('input[name=quantity]')
                  ? form.querySelector('input[name=quantity]').value
                  : '1';

      window.location.href = '/cart/add?id=' +
                             encodeURIComponent(productId) +
                             '&quantity=' +
                             encodeURIComponent(qty);
    } catch (err) {
      console.warn('[B&B] quick-add error:', err);
    }
  });

  // ── Lazy-load images with IntersectionObserver ───────────────────────
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[data-src]');
    if (lazyImages.length) {
      var imgObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            img.src = img.dataset.src;
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            imgObserver.unobserve(img);
          }
        });
      });
      lazyImages.forEach(function (img) { imgObserver.observe(img); });
    }
  }

  // ── Search toggle (placeholder) ──────────────────────────────────────
  var searchToggle = document.querySelector('.search-toggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var form = document.querySelector('.search-form-wrapper');
      if (form) form.classList.toggle('is-open');
    });
  }

})();
